import { Capacitor } from "@capacitor/core";

export type TerrainSenseReleaseMode = "OFF" | "LAB" | "BETA";

function configuredMode(): TerrainSenseReleaseMode {
  const value = String(import.meta.env.VITE_TERRAIN_SENSE_MODE ?? "LAB").toUpperCase();
  return value === "OFF" || value === "BETA" ? value : "LAB";
}

export const TERRAIN_SENSE_VERSION = "1.0.0-LAB-FOUNDATION";
export const TERRAIN_SENSE_RELEASE_MODE = configuredMode();

export function isTerrainSenseEntryAvailable() {
  return TERRAIN_SENSE_RELEASE_MODE !== "OFF"
    && Capacitor.isNativePlatform()
    && Capacitor.getPlatform() === "android";
}
